import { ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { element } from 'protractor';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-dropdown-input-type',
  templateUrl: './dropdown-input-type.component.html',
  styleUrls: ['./dropdown-input-type.component.css'],
  providers: []

})
export class DropdownInputTypeComponent implements OnInit, OnChanges {
  @Output() selectionChange :EventEmitter<any> = new EventEmitter()
  @Output() selectionObjectChange :EventEmitter<any> = new EventEmitter()
  @Output() unselect :EventEmitter<any> = new EventEmitter()
  @Output() selectValueChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() selectLabelChanges:EventEmitter<any> = new EventEmitter<any>();
  @Input() selectValue: string = "";
  @Input() getAllFn;
  @Input() isMultiple = false;
  @Input() keepItOpen = false;
  @Input() label: string;
  @Input() searchPlaceHolder: string = 'Search';
  @Input() noEntriesFoundLabel: string = 'No items found';
  @Input() bindValue: string = 'id';
  @Input() bindKey: string = 'displayName';
  @Input() formKey: string ='formKey';
  @Input() customFilterKey: string ='';
  @Input() customFilterValue: string | number ='';
  @Input() showNoneOption: boolean = false;
  @Input() set parentControl(value : UntypedFormGroup){
    this._parentControl = value ?? this.fb.group({formKey:[this.selectValue]})
  }
  get parentControl(){
    return this._parentControl ?? this.fb.group({formKey:[this.selectValue]})
  }
  @Input() appearance: MatFormFieldAppearance = 'legacy';
  @Input() isRequired: boolean = false;
  @Input() readonly: boolean = false;
  @Input() fieldClass: string = 'w-100';
  @Input() bindKeyTemplate: TemplateRef<any>;
  @Input() errorTemplate: TemplateRef<any>;
  @Input() hintTemplate: TemplateRef<any>;
  @Input() SearchQuery : string =''
  @Input() set start(value : boolean){
    this._start = value;
    value ? this.startHttpSearch() : null;
  }
  get start (){
    return this._start;
  }
  _start = true;
  total = 1;
  PerPage = 10;
  Page = 1;
  options: any = [];
  searchForm = new UntypedFormControl('');
  control: AbstractControl;
  _parentControl : UntypedFormGroup;
  selectedOptions:any[]=[]

 
  constructor(private fb : UntypedFormBuilder,
              private ref:ChangeDetectorRef) { }

  ngOnInit(): void {
    if(this.parentControl && this.parentControl.get(this.formKey)?.value){
      this.selectValue = this.parentControl.get(this.formKey).value
    }
    this.subscribeToSearchValueChanges();
    this.startHttpSearch();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.parentControl?.previousValue != changes?.parentControl?.currentValue) {
      this.control = this.parentControl.get(this.formKey);
    }
  }
  infiniteScroll() {
    this.startHttpSearch()
  }
  private subscribeToSearchValueChanges(): void {
    this.searchForm.valueChanges
      .pipe(
        distinctUntilChanged(),
        debounceTime(700)
      )
      .subscribe(value => {
        this.resetPagination()
        this.SearchQuery = value ?? ''
        this.startHttpSearch();
      })
  }

  private startHttpSearch(): void {
    if ((this.options.length < this.total || this.total == 0) && this.start === true && this.getAllFn) {
      let filter={}
      filter['SearchQuery']=this.SearchQuery ?? '';
      if(this.customFilterKey)
      filter[this.customFilterKey]=this.customFilterValue ?? '';

      this.getAllFn(
        filter,
        this.Page,
        this.PerPage
      ).subscribe((res) => {
       
        this.options = [...(res?.body.data ?? res)]
        this.selectedOptions.forEach(ele =>{
          if(!this.options.find(x => x.id ==ele.id))
          this.options.push(ele)
        })
      
        this.ref.detectChanges()
        this.total = res?.body.totalCount ?? 1
        this.PerPage += this.PerPage;
      });
    }
  }
  onSelectionChange(event){
    console.log(event)
    let labels=[]
    this.options.forEach(element=>{
      if(event && Array.isArray(event) && event.includes(element.id))
      labels.push(element)
    })
    this.selectedOptions=[...labels]
    console.log(event)
    this.selectLabelChanges.emit(labels)
    this.selectionChange.emit(event)
    if(!this.isMultiple)
    this.selectionObjectChange.emit(this.options.find(item=>item[this.bindValue]==event));
    else{
    this.selectionObjectChange.emit(this.options.filter(item=>event.includes(item[this.bindValue])));

    }
  }

  resetPagination(){
    this.PerPage = 10
    this.Page = 1;

    this.options = [];
  }

  reload(){
    this.resetPagination();
    this.startHttpSearch();
  }
  unSelectOption(ev: Event) {
    this.unselect.emit(null);
    this.resetPagination();
    this.startHttpSearch();
  }
}
